import { render, staticRenderFns } from "./NormalNotice.vue?vue&type=template&id=0841dc21&scoped=true&"
import script from "./NormalNotice.vue?vue&type=script&lang=ts&"
export * from "./NormalNotice.vue?vue&type=script&lang=ts&"
import style0 from "./NormalNotice.vue?vue&type=style&index=0&id=0841dc21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0841dc21",
  null
  
)

export default component.exports